import builder from '../reducerBuilder'
import {
  ACTION_COGOLAND_USERS_WITH_STATUS_ERROR,
  ACTION_COGOLAND_USERS_WITH_STATUS_LOADED,
  ACTION_COGOLAND_USERS_WITH_STATUS_LOADING,

} from '../../constants'

export default builder(
  [ACTION_COGOLAND_USERS_WITH_STATUS_LOADING],
  [ACTION_COGOLAND_USERS_WITH_STATUS_LOADED],
  [ACTION_COGOLAND_USERS_WITH_STATUS_ERROR])



// WEBPACK FOOTER //
// ./src/store/cogoland/usersWithStatusReducer.js